/**
 * Утилиты для работы с устройствами ввода
 * @packageDocumentation
 */

/**
 * Перевод строки в другую раскладку
 */
export const invertKeyboardLayout = (string: string): string => {
	const a1 = 'qwertyuiop[]asdfghjkl;\'zxcvbnm,./QWERTYUIOP{}ASDFGHJKL;"ZXCVBNM<>?';
	const a2 = 'йцукенгшщзхъфывапролджэячсмитьбю.ЙЦУКЕНГШЩЗХЪФЫВАПРОЛДжЭЯЧСМИТЬБЮ,';
	let indexFinded: number;

	const chars: Array<string> = string.split('');
	chars.forEach((char: string, index: number) => {
		indexFinded = a1.indexOf(char);
		if (indexFinded !== -1) {
			chars[index] = a2[indexFinded];
		} else {
			indexFinded = a2.indexOf(char);
			if (indexFinded !== -1) {
				chars[index] = a1[indexFinded];
			}
		}
	});
	string = chars.join('');

	return string;
};
